export enum AMENITIE_TYPES {
  ENTERTAINMENT = 0,
  POWER = 1,
  WIFI = 2
}
